{
    "role": "JDF SIGNER",
    "emailID": "***********",
    "name":"JDF Signer",
    "recipientId":"111",
    "routingOrder": 7,
    "signingOption": "Sign by email",
    "countryCodeforPhone": "**",
    "contactNumber": "***********"
  }
